import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

// A person against a hatched (blurred) background. The hatching is cut out around the silhouette
// by a mask; its id is per instance, since the icon is on the page more than once.
export const BlurPersonIcon = (props: SvgIconProps) => {
	const maskId = `blur-person-mask-${React.useId().replace(/:/g, '')}`;

	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			<defs>
				<mask id={maskId}>
					<rect width="24" height="24" fill="white" />
					<circle cx="12" cy="8.5" r="4.5" fill="black" />
					<path d="M3 25C3 18 7 14 12 14C17 14 21 18 21 25H3Z" fill="black" />
				</mask>
			</defs>
			<g mask={`url(#${maskId})`} stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" opacity="0.3">
				<line x1="-18" y1="24" x2="6" y2="0" />
				<line x1="-12" y1="24" x2="12" y2="0" />
				<line x1="-6" y1="24" x2="18" y2="0" />
				<line x1="0" y1="24" x2="24" y2="0" />
				<line x1="6" y1="24" x2="30" y2="0" />
				<line x1="12" y1="24" x2="36" y2="0" />
				<line x1="18" y1="24" x2="42" y2="0" />
			</g>
			<circle cx="12" cy="8.5" r="3.5" fill="none" stroke="currentColor" strokeWidth="2" />
			<path d="M4 24C4 18.5 7.5 15 12 15C16.5 15 20 18.5 20 24" fill="none" stroke="currentColor" strokeWidth="2" />
		</SvgIcon>
	);
};
